export default "<mat-icon *ngIf=\"icon\" aria-hidden=\"true\">{{ icon }}</mat-icon>\n<span>\n  <ng-content></ng-content>\n</span>\n"